import React, { Component } from 'react';

import { GenericOption } from 'com-gyf-webcore-userinterfacecomponents';

import TagUsuario from './TagUsuario';

let usersFound = undefined;
let userPropKeyLogin = "Login";
let userPropKeyNombre = "Nombre";
let keyWasPressed = false;

class BusquedaUsuario extends Component {
    constructor(props) {
        super(props);

        this.state = {
            textLogin: '',
            userFound: true,
            showErrorMessage: false
        }

        this.limpiarFiltro = this.limpiarFiltro.bind(this);
    }

    onPasteText(e) {
        e.preventDefault();
        e.nativeEvent.stopImmediatePropagation();
    }


    addUser = (event) => {
        const { props } = this;

        let term = event.target.value.toString().toLowerCase();
        let showErrorMessage = false;
        let usersFound = undefined;
        let oneUserFound = undefined;

        let loginsAdded = props.usuariosSeleccionados.map(function (usuario) {
            return usuario.Login;
        });

        let users = props.usuarios.filter(function (usuario) {
            if (!props.usuariosSeleccionados) {
                return usuario;
            }
            else {
                let index = loginsAdded.indexOf(usuario.Login);
                if (index < 0) {
                    return usuario;
                }
            }
        });        

        if (term != "") {
            showErrorMessage = true;
            term = term.replace("(", "").replace(")", "");
            //Descomentar o comentar si debe o no quitar los espacios de inicio y final en el string
            term = term.replace(/^\s+|\s+$/g, "");

            let terms = term.split(/\s/g);

            /*
            usersFound = users.filter(function (u) {
                let propLogin = (u[userPropKeyLogin] || "").toString().toLowerCase();
                //let propNombre = (u[userPropKeyNombre] || "").toString().toLowerCase();
                let logins = propLogin.split(/\s/g);
                //let nombres = propNombre.split(/\s/g);

                if (!keyWasPressed) {
                    return logins.find(function (n) {
                        return (terms.find(function (t) { return (t == n); }));
                    });
                } else {
                    if (propLogin.includes(term)) {
                        return true;
                    } /*else {
                        if (terms.length > 1) {
                            return nombres.find(function (n) {
                                return (terms.find(function (t) { return (t == n); }));
                            });
                        } else {
                            return propNombre.includes(term);
                        }
                    }
                }
            });*/

             usersFound = users.filter(x => (x.Login || "").toString().toLowerCase() == (term || "").toString().toLowerCase());
            //usersFound = users.filter((p) => { return (p.Login != null && p.Login.toString().toLowerCase().match(term)) });

        }

        if (usersFound && usersFound.length == 1 && !keyWasPressed) {
            this.props.addUsuario(usersFound[0].Login);

            this.setState({ textLogin: '' });

            this.setState({ showErrorMessage: false });
        }
        else {
            this.setState({ textLogin: event.target.value, userFound: (usersFound && usersFound.length > 0), showErrorMessage });
        }

        keyWasPressed = false;
    }

    keyDown = (event) => {
        //backspace = 8, tab = 9, enter = 13, ctrol = 17, shift = 16, alt = 18, [left = 37, up = 38, rigth = 39, down = 40] (flechas)
        //=> no se deben considerar como tecla presionada

        let keyNotAllowed = [8, 9, 13, 16, 17, 18, 37, 38, 39, 40];

        if (keyNotAllowed.indexOf(event.keyCode) < 0) {
            keyWasPressed = false;
        }
    }

    onFocus = (event) => {
        keyWasPressed = false;
    }

    onKeyPress = (event) => {
        let regExp = /[a-z0-9]/ig;

        if (!regExp.test(event.key)) {
            event.preventDefault();
        }
    }

    limpiarFiltro() {
        this.setState({ textLogin: "" });
        this.setState({ showErrorMessage: false });
    }

    render() {
        const { props } = this;

        let messageError = <label className="error zmdi-alert-circle">No se encontro el usuario buscado</label>;
        let showMessage = (!this.state.userFound && this.state.showErrorMessage);

        var oUsers = props.usuarios.map(function (usuario) {
            if ( usuario.Eliminado === false ) {
                return (
                    <GenericOption id={usuario.Login} description={usuario.Nombre + " (" + usuario.Login + ")"} key={"Usuario_" + usuario.Id} />
                );
            } 
        });

        var oUsersName = props.usuariosSeleccionados.map(function (usuario) {
            return (
                <TagUsuario loginName={usuario.Login} key={usuario.Id} deleteUsuario={props.deleteUsuario} />
            );
        });

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <h3 className="divisor-section">...y/o a los usuarios...</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6 search bottom-separator-xxs">
                            <span className="ti-search"></span>
                            <input list="usersList" id="txtBusquedaNombreLogin"
                                className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs BusquedaUsuario-searchUser"
                                value={this.state.textLogin}
                                maxLength="40"
                                onChange={this.addUser}
                                onKeyDown={this.keyDown}
                                onFocus={this.onFocus}
                                onKeyPress={(e) => this.onKeyPress(e)}
                                onPaste={this.onPasteText}
                                placeholder="Buscar usuarios por nombre o login..." />
                            <input id="textUser" type="hidden" />
                            <span>{showMessage && messageError}</span>
                        </div>

                        {this.state.textLogin.length > 0 ?
                        <div className="BusquedaUsuario-btn-group-Borrar-Filtro">
                            <button id={"botonBorrarFiltroBuscarEntidad"} type="button" className="btn-tag BusquedaUsuario-Filtros-Limpiar-Filtro"
                                onClick={this.limpiarFiltro}>
                                <span id={"botonBorrarXFiltroBuscarEntidad"} className="ti-close span-closable" />
                            </button>
                        </div>
                        :
                        null}
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <datalist id="usersList">
                                {oUsers}
                            </datalist>
                        </div>
                        <div className="col-xs-12">
                            <ul id="userList" className="no-bullets no-margin-bottom">
                                {oUsersName}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BusquedaUsuario;